import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './contact-country-accordions.component.scss';
import * as $ from 'jquery';
var ContactCountryAccordions = /** @class */ (function (_super) {
    tslib_1.__extends(ContactCountryAccordions, _super);
    function ContactCountryAccordions(element) {
        return _super.call(this, element) || this;
    }
    ContactCountryAccordions.prototype.init = function () {
        this.accordionTriggers = Array.from(this.element.querySelectorAll('.js-accordion-trigger'));
        this.collapseTriggers = Array.from(this.element.querySelectorAll('.js-collapse-trigger'));
    };
    ContactCountryAccordions.prototype.bindEvents = function () {
        var _this = this;
        if (this.accordionTriggers) {
            this.accordionTriggers.map(function (item) { return item.addEventListener('click', function (event) {
                _this.toggleAccordions(event);
            }); });
        }
        if (this.collapseTriggers) {
            this.collapseTriggers.map(function (item) { return item.addEventListener('click', function (event) {
                _this.toggleCollapses(event);
            }); });
        }
    };
    ContactCountryAccordions.prototype.toggleAccordions = function (event) {
        var _target = event.target;
        var _selected = _target.closest('.js-accordion-trigger');
        if (_selected.classList.contains('accordion__item--open')) {
            this.closeAccordion();
        }
        else {
            this.closeAccordion();
            this.openAccordion(event);
        }
    };
    ContactCountryAccordions.prototype.toggleCollapses = function (event) {
        var _target = event.target;
        var _parent = _target.closest('.accordion--collapse');
        var _container = _parent.querySelector('.accordion--collapse__container');
        var _containerInner = _container.querySelector('.accordion--collapse__container--inner');
        var _varInnerHeight = _containerInner.offsetHeight;
        if (_parent.classList.contains('accordion--collapse__opened')) {
            _container.style.height = "0px";
            setTimeout(function () {
                _parent.classList.remove('accordion--collapse__opened');
            }, 300);
        }
        else {
            _container.style.height = _varInnerHeight + "px";
            _parent.classList.add('accordion--collapse__opened');
        }
    };
    ContactCountryAccordions.prototype.closeAccordion = function () {
        var _activeAccordionTrigger = Array.from(this.element.querySelectorAll('.accordion__item--open'));
        var _activeAccordion = Array.from(this.element.querySelectorAll('.accordion__item-content--open'));
        _activeAccordionTrigger.map(function (_elem) {
            _elem.classList.remove('accordion__item--open');
            _elem.classList.add('accordion__item--closed');
        });
        _activeAccordion.map(function (_elemContent) {
            _elemContent.classList.remove('accordion__item-content--open');
            _elemContent.classList.add('accordion__item-content--closed');
        });
    };
    ContactCountryAccordions.prototype.openAccordion = function (event) {
        var _target = event.target;
        var _selectedParent = _target.closest('.js-accordion-trigger');
        setTimeout(function () {
            var _selected = _selectedParent.parentElement.querySelector('.accordion__item--closed');
            var _selectedContent = _selectedParent.parentElement.querySelector('.accordion__item-content--closed');
            _selected.classList.remove('accordion__item--closed');
            _selected.classList.add('accordion__item--open');
            _selectedContent.classList.remove('accordion__item-content--closed');
            _selectedContent.classList.add('accordion__item-content--open');
            if (document.querySelector('.header').classList.contains('header--sticky')) {
                $('html,body').animate({
                    scrollTop: $(_selected).offset().top - 65
                }, 'slow');
            }
            else {
                $('html,body').animate({
                    scrollTop: $(_selected).offset().top - 195
                }, 'slow');
            }
        }, 700);
    };
    return ContactCountryAccordions;
}(Base));
export { ContactCountryAccordions };



//////////////////
// WEBPACK FOOTER
// ./components/contact-country-accordions/contact-country-accordions.component.ts
// module id = 207
// module chunks = 0